<template>
    <div class="main">
        <download-Popup></download-Popup>

        <p class="operamini-tips" v-if="isOperamini">In order to give you a better experience, please download our
            professional APP.</p>
        <downloadheader v-show="downLoadHeaderShow" id="headwrap"></downloadheader>
        <navVue :subtitleData="getMatchSubTabList" :navSelected="currentNavTag"></navVue>
        <div class="contentWrap" id="contentWrap">
            <!-- 没数据 -->
            <nodata v-if="getMatchNoDataMode && !getMatchLoadingShow" :whiteMode="true"></nodata>
            <!-- 列表详情 -->
            <div class="listwrap" id="listwrap" v-if="!getMatchNoDataMode && !getMatchLoadingShow">
                <div v-for="(item, key, index) in getFinalListSplitDateData" :key="index">
                    <p class="dateTit"><span>{{key}}</span> <em>{{item.localdate}}</em></p>
                    <div class="sameDateData" v-for="(elem, index) in item"
                         v-bind:id="setAnchor(elem.isLastEnd, index)" :key="index">
                        <div class="list">
                            <!-- <a :href="'/matchDetail?id='+elem.match_id+'&subtitle='+subtitChoose" class="clearfix"> -->
                            <a :href="`/match/${subtitChoose}/${elem.team_A_name.replace(/\s/g, '-')}-vs-${elem.team_B_name.replace(/\s/g, '-')}/${elem.match_id}`" class="clearfix">
                                <dl class="flwrap">
                                    <dt><img :data-src="getImgSrc(elem.team_A_logo)" v-team-logo class="teamlogo"></dt>
                                    <dd>{{elem.team_A_name}}</dd>
                                </dl>

                                <div class="unStart_competewrap competewrap" v-if="elem.status==='Fixture'">
                                    <div class="unStartInfor">
                                        <p class="competename">{{elem.competition_name}} {{elem.gameweek}}</p>
                                        <p class="vs">vs</p>
                                        <p class="unStartTime"><span class="unStartLive"
                                                                     v-if="elem.webLivingFlag">LIVE</span>{{tran12(elem.localdate.local_hms)}}
                                        </p>
                                    </div>
                                </div>
                                <div class="unStart_competewrap competewrap"
                                     v-if="elem.status==='Postponed'||elem.status==='Cancelled'||elem.status==='Suspended'">
                                    <div class="unStartInfor">
                                        <p class="competename">{{elem.competition_name}} {{elem.gameweek}}</p>
                                        <p class="vs">vs</p>
                                        <p class="unStartTime"><span class="unStartLive"
                                                                     v-if="elem.webLivingFlag">LIVE</span>{{elem.status}}
                                        </p>
                                    </div>
                                </div>
                                <div class="statusPlaying_competewrap competewrap" v-if="elem.status==='Playing'">
                                    <div class="playingUnLive">
                                        <p class="competename">{{elem.competition_name}} {{elem.gameweek}}</p>
                                        <p class="playingScore"><span>{{elem.fs_A}}</span><em class="dot">:</em><span>{{elem.fs_B}}</span>
                                        </p>
                                        <p class="playingUnliveTime" v-if="!elem.webLivingFlag">
                                            {{elem.playing_time}}'</p>
                                        <p class="playingLiveTime" v-if="elem.webLivingFlag"><img
                                            src="../assets/video/video_arrow.png" class="video_arrow"><span class="fl">LIVE IN {{elem.playing_time}}'</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="statusEnd_competewrap competewrap" v-if="elem.status==='Played'">
                                    <p class="competename">{{elem.competition_name}} {{elem.gameweek}}</p>
                                    <p class="compete-center mb5"><span>{{elem.fs_A}}</span><em class="line"></em><span>{{elem.fs_B}}</span>
                                    </p>
                                    <p class="status">end</p>
                                </div>

                                <dl class="frwrap">
                                    <dt><img :data-src="getImgSrc(elem.team_B_logo)" v-team-logo class="teamlogo"></dt>
                                    <dd>{{elem.team_B_name}}</dd>
                                </dl>
                            </a>
                        </div>
                    </div>
                </div>
                <downloadfooter v-if="getDownloadFooterShow"
                                text="Download All Football for more matches"></downloadfooter>
            </div>
            <!-- loading -->
            <loading v-if="getMatchLoadingShow"></loading>
        </div>
    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import downloadheader from '@/components/downloadHeader.vue';
    import downloadfooter from '@/components/downloadFooter.vue';
    import navVue from '@/components/navNew.vue';
    import loading from '@/components/loading.vue';
    import nodata from '@/components/nodata.vue';
    import downloadPopup from '@/components/downloadPopup.vue';
    // import axios from 'axios';
    // import VueScroller from 'vue-scroller'
    // Vue.use(VueScroller)
    export default {
        name: 'app',
        data () {
            return {
                currentNavTag: 'MATCH',
                // initUrl: '/m/app/global/2/m.json?menu=match&plat=m',
                downLoadHeaderShow: true,
                // subtitChoose: '',
                // subtitData: [],
                // currentListData: [],
                // finalListSplitDateData: {},
                // subtitle: '',
                scroll: 0,
                // getDataUrlApi: '',
                // loadingShow: true,
                // noDataMode: false,
                // downloadFooterShow: false,
                is_jump: true, // 是否跳转到锚点
                isOperamini: false
            };
        },
        computed: {
            ...mapGetters([
                'getMatchSubTabList',
                'getMatchLoading',
                'getMatchNoDataMode',
                'getMatchLoadingShow',
                'getDownloadFooterShow',
                'getCurrentMatchListData',
                'getFinalListSplitDateData'
            ]),
            subtitChoose () {
                return this.$store.state.navStore.subtitChoose;
            }
        },
        asyncData ({ store, route: { params: { subtitle } } }) {
            let date = new Date();
            let localYear = date.getFullYear();
            let localMonth = date.getMonth() + 1;
            let localDay = date.getDate();
            let localDate = localYear + '/' + localMonth + '/' + localDay + ' 00:00:00';
            let finalLocal = new Date(localDate);
            let local_date = finalLocal.getTime();
            let diff_min = new Date().getTimezoneOffset();
            let utcTime = local_date + diff_min * 60 * 1000;
            let utc = new Date(utcTime);
            let y = utc.getFullYear();
            let m = utc.getMonth() + 1;
            let d = utc.getDate();
            let h = utc.getHours();
            let min = utc.getMinutes();
            let s = utc.getSeconds();
            let finalDate = '' + y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s;
            console.log('--subtitle---', subtitle);
            let allFetch = async () => {
                let menus = await store.dispatch('menusListApi', { subtitle, type: 'MATCH' });
                const chooseArr = store.getters.getMatchSubTabList.filter(ele => {
                    return ele.label === store.state.navStore.subtitChoose;
                });
                const urlApi = (chooseArr && chooseArr.length && chooseArr[0].urlApi) || '';
                let matchList = await store.dispatch('matchListApi', { urlApi, finalDate });
                return Promise.all([
                    menus,
                    matchList
                ]);
            };
            return allFetch();
        },
        created: function () {
            // this.getInitData();
        },
        mounted: function () {
            let that = this;
            this.onScroll = function () {
                let utilObj = require('@/util/util.js');
                utilObj.lazyload('listwrap', 'teamlogo');
                that.stickyFn();
            };
            window.addEventListener('scroll', this.onScroll, false);
            let utilObj = require('@/util/util.js');
            utilObj.timeForInOut();
            this.isOperamini = utilObj.checkOperamini();
        },
        updated: function () {
            console.log('update:||||||||');
            let utilObj = require('@/util/util.js');
            utilObj.lazyload('listwrap', 'teamlogo');
        },
        head () {
            const referer = this.subtitChoose
            return {
                // 域名归一（阶段1）：赛程列表的规范版本是 www 比分频道页
                link: [{
                    vmid: 'canonical',
                    rel: 'canonical',
                    href: 'https://www.allfootballapp.com/match'
                }],
                title: `${referer} football matchs，Live Scores，Match analysis | All Football`,
                meta: [
                    {
                        name: 'description',
                        content: `The ${referer} football match details, including live text commentary, team line-ups, match analysis, odds...`
                    },
                    {
                        name: 'keywords',
                        content: `football app, allfootballapp.com,  ${referer} matchs, All Football, ${referer} live scores, ${referer} scores, `
                    }
                ]
            };
        },
        methods: {
            // 转换成12小时制方法
            tran12 (time) {
                // (elem.localdate.local_hms).replace(":","") < 1200 ? 'AM '+elem.localdate.local_hms : 'FM '
                let time_arr = time.split(':');
                if (time_arr[0] > 12) {
                    var result = (time_arr[0] - 12) + ':' + time_arr[1] + ' FM';
                } else {
                    var result = time_arr[0] + ':' + time_arr[1] + ' AM';
                }
                return result;
            },
            // 设置锚点
            setAnchor (isLastEnd, index) {
                if (isLastEnd && index != 1) {
                    this.is_jump = true;
                    return 'there';
                }
            },
            subNavTranslateX: function (index) {
                let screenWidth = document.documentElement.clientWidth;
                this.scrollLeft = document.getElementById('scroll').scrollLeft;
                this.leftToScreen = $('#scroll span').eq(index)[0].getBoundingClientRect().left;
                this.rightToScreen = screenWidth - ($('#scroll span').eq(index)[0].getBoundingClientRect().left + $('#scroll span').eq(index).width());
                let average = (this.leftToScreen + this.rightToScreen) / 2;
                if (this.leftToScreen < this.rightToScreen) {
                    document.getElementById('scroll').scrollLeft -= (average - this.leftToScreen);
                } else {
                    document.getElementById('scroll').scrollLeft += (average - this.rightToScreen);
                }
            },
            stickyFn: function (ev) {
                window.browers = {};
                var ua = navigator.userAgent.toLowerCase();
                browers.Android = ua.match(/android/);
                browers.iOS = ua.match(/ipad|iphone|ios/);
                if (browers.Android) {
                    let topFixedWrap = document.getElementById('topFixedWrap');
                    if (!topFixedWrap) {
                        return;
                    }
                    let topFixedWrapHeight = topFixedWrap.offsetHeight; // 被定住的位置的高度
                    this.scroll = document.body.scrollTop;
                    let headwrap = document.getElementById('headwrap');
                    let headHeight = headwrap.offsetHeight; // 下载条的高度
                    let contentWrap = document.getElementById('contentWrap'); // 每个二级导航下的列表内容
                    if (this.scroll >= headHeight) {
                        topFixedWrap.className = 'topFixedWrap tab-box-fixed';
                        contentWrap.style.paddingTop = topFixedWrapHeight + 'px';
                    } else {
                        topFixedWrap.className = 'topFixedWrap';
                        contentWrap.style.paddingTop = 0 + 'px';
                    }
                }
            },
            // updateMatchList: function (url) {
            //     let that = this;
            //     // 子组件navVue向本组件通信 - 点击副导航 -> 更新新闻列表
            //     this.loadingShow = true;
            //     Vue.set(that, 'currentListData', []);
            //     Vue.set(that, 'finalListSplitDateData', {});
            //     axios.get(global.apiDomain + url).then((res) => {
            //         if (res.data.list) {
            //             console.log(res.data.list);
            //             that.currentListData = res.data.list;
            //             if (res.data.list.length == 0) {
            //                 that.noDataMode = true;
            //                 that.loadingShow = false;
            //                 that.downloadFooterShow = true;
            //             } else {
            //                 that.noDataMode = false;
            //                 that.loadingShow = true;
            //                 that.downloadFooterShow = false;
            //                 that.currentListData.forEach((elem, index) => {
            //                     var obj = that.formatDate(elem.start_play);
            //                     elem.localdate = obj;
            //                     if (!that.finalListSplitDateData[elem.localdate.local_ymd + ' ' + elem.localdate.local_day]) {
            //                         that.finalListSplitDateData[elem.localdate.local_ymd + ' ' + elem.localdate.local_day] = [];
            //                     }
            //                     that.finalListSplitDateData[elem.localdate.local_ymd + ' ' + elem.localdate.local_day][that.finalListSplitDateData[elem.localdate.local_ymd + ' ' + elem.localdate.local_day].length] = elem;
            //                     that.loadingShow = false;
            //                     that.downloadFooterShow = true;
            //                 });
            //             }
            //         } else {
            //             console.log('接口数据有问题，没有接受到正确数据');
            //         }
            //     }, res => {
            //         // error callback
            //     });
            // },
            // updateSubNav: function (data) {
            //     // 子组件navVue向本组件通信 - 初始化副导航展示
            //     let finalDate = this.dateToUtc();
            //     this.subtitChoose = data.subtitChooseObj;
            //     this.getDataUrlApi = data.getDataUrlApiObj + '?start=' + finalDate;
            //     // 副导航更新后更新新闻列表
            //     this.updateMatchList(this.getDataUrlApi);
            //     this.updateTitle(this.subtitChoose);
            // },
            // updateTitle: function () {
            //     if (this.subtitChoose === 'Main' || this.subtitChoose === 'Global') {
            //         document.title = 'All Football - Live Scores, News, Videos & Highlights';
            //     } else {
            //         document.title = 'All Football -' + this.subtitChoose + ' Live Scores, News, Videos & Highlights';
            //     }
            // }
        },
        components: {
            downloadheader, downloadfooter, navVue, loading, nodata, downloadPopup
        }
    };
</script>

<style lang="less" scoped>
    .listwrap {
        height: auto;
        overflow: hidden;
    }

    .dateTit {
        text-align: center;
        color: #8c9399;
        font-size: .8rem;
        margin: 0 auto;
        height: 2rem;
        line-height: 2rem;
        background: #eff1f4;
    }

    .list {
        height: 5.4rem;
        overflow: hidden;
        position: relative;
        border-bottom: 1px solid #eff1f4;
        background: #fff;
    }

    .list dl {
        width: 6.4rem;
    }

    .list dl dt {
        width: 2.2rem;
        height: 2.2rem;
        overflow: hidden;
        text-align: center;
        margin: 0 auto .4rem;
    }

    .list dl dt img {
        width: 100%;
        display: block;
    }

    .list dl dd {
        text-align: center;
        font-size: 0.68rem;
        color: #606369;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .flwrap {
        float: left;
        margin: .9rem 0 .9rem .6rem;
    }

    .frwrap {
        float: right;
        margin: .9rem .6rem .9rem 0;
    }

    .line {
        width: .6rem;
        height: .12rem;
        display: inline-block;
        background: #333d46;
        position: relative;
        top: -0.4rem;
        margin: 0 1rem;
    }

    .competewrap {
        box-sizing: border-box;
        // padding-top: .7rem;
        font-size: 1.2rem;
        width: 10.4rem;
        // height: 4.5rem;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        margin-top: .58rem;
    }

    .competename {
        font-size: 12px;
        line-height: 14px;
        color: #8c9399;
        // margin-bottom: 0.5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .mb5 {
        // margin-bottom: 0.067rem;
    }

    .compete-center {
        margin: .43rem 0;
    }

    .status {
        font-size: 12px;
        line-height: 14px;
        color: #8c9399
    }

    .list a {
        display: block;
    }

    .dot {
        color: #16b13a;
        width: 2rem;
        display: inline-block;
        position: relative;
        top: -0.04rem;
        font-size: 1rem;
        font-style: normal;
    }

    .playingScore, playingLive {
        color: #16b13a;
        margin-bottom: 0.4rem;
        line-height: 1.2rem;
    }

    .playingUnliveTime {
        color: #16b13a;
        font-size: 0.8rem;
    }

    .statusPlaying_competewrap .competename {
        margin-bottom: 0.4rem;
    }

    .playingLiveTime {
        width: 6rem;
        height: 1rem;
        background: #16b13a;
        margin: 0 auto;
        color: #fff;
        font-size: 0.6rem;
        line-height: 1rem;
        border-radius: 0.02rem;
    }

    .video_arrow {
        width: 0.36rem;
        height: 0.5rem;
        float: left;
        margin: 0.3rem 0.2rem 0 0.5rem;
    }

    .unStart_competewrap {
        color: #606369;
        font-size: 1rem;
    }

    .statusPlaying_competewrap {
        color: #16b13a;
    }

    .statusEnd_competewrap {
        color: #2d2f32;
    }

    .vs {
        line-height: 1.2rem;
        color: #606369;
        font-size: 1.2rem;
        margin: 0.59rem 0;
    }

    .unStartLive {
        color: #16ac3a;
        font-size: 0.6rem;
        width: 2.4rem;
        height: 1rem;
        border: 1px solid #16ac3a;
        display: inline-block;
        line-height: 1rem;
        border-radius: 0.01rem;
        position: relative;
        left: -0.1rem;
        top: 0rem;
        transform: scale(0.7);
    }

    .unStartTime {
        color: #8c9399;
        font-size: 0.68rem;
        line-height: 12px;
    }

    .loadwrap {
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2rem;
        color: #8c9399;
        background: #eff1f4;
        text-align: center;
        margin: 0 !important;
        line-height: 2rem;
        font-size: 0.68rem;
    }

    .loadingicon {
        width: 1rem;
        height: 1rem;
        background: url(../assets/home/loading-icon.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: .5rem;
        left: 0rem;

        animation: rotate linear 1.2s both infinite;
        -webkit-animation: rotate linear 1.2s both infinite;
    }

    .loading {
        width: 6rem;
        margin: 0 auto;
        height: 2rem;
        line-height: 2rem;
        position: relative;
    }

    @keyframes rotate {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes rotate {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .loadingtext {
        text-indent: 0.4rem;
        display: inline-block;
    }

    .contentWrap {
        min-height: 38rem;
    }

    .operamini-tips {
        background: #FFFF00;
        text-align: center;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// AppMatch.vue?d9bd3ade